import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { finchatMessageLoad } from "../redux/slices/finchatSlice";

const makeUserMessage = (text: string) => {
  return {
    isBot: false,
    output: text,
  };
};

const useFetchMessages = (sessionIdSafe, user_id, accessToken, setMessages) => {
  const dispatch = useDispatch();

  const fetchMessages = useCallback((text, input_type) => {
    if (text.trim()) {
      const chat_id = uuidv4();
      dispatch(
        finchatMessageLoad({
          input: text,
          chat_id,
          session_id: sessionIdSafe,
          user_id,
          accessToken,
          input_type,
        }),
      );

      setMessages((allMessages) => {
        const prevMessages = allMessages[sessionIdSafe] || [];

        return {
          ...allMessages,
          [sessionIdSafe]: [
            ...prevMessages,
            makeUserMessage(text),
          ],
        };
      });
    }
  }, [dispatch, sessionIdSafe, user_id, accessToken, setMessages]);

  return fetchMessages;
};

export default useFetchMessages;
